module.exports = __webpack_public_path__ + "static/media/rnr.3008e5a7.svg";